"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MenuIco = function MenuIco(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width,
    height: props.height,
    viewBox: "0 0 30 19"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#4A4A4A",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "30",
    height: "3",
    rx: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    width: "22",
    height: "3",
    y: "8",
    rx: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    width: "26",
    height: "3",
    y: "16",
    rx: "1.5"
  })));
};

var _default = MenuIco;
exports["default"] = _default;